import { FunctionComponent } from 'react';
import Select, { components } from 'react-select';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';

import { Option } from 'types/options';

import InputWrapper, { ValidationActions } from 'components/layout/forms/InputWrapper';

import { Props } from './index';
import StyledComponent from './styles';

const LayoutFormsSelect: FunctionComponent<Props> = ({ formik, name, label, placeholder, helper, value, onChange, error, disabled, style, styles, options, validationAction, decoratorLeft, decoratorRight, inputProps, customStyles, emptyText }) => {
    const errorMessage = formik?.errors[name]?.toString() || error;

    if(options.length > 0 && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
        const selectedOption = options.find((option: Option<any>) => option.value === value);
        value = selectedOption || value;
    }

    const DropdownIndicator = props => {
        return (
            <components.DropdownIndicator {...props}>
                <FontAwesomeIcon
                    icon={faCaretDown}
                    color="#BA9449"
                    height={20}

                />
            </components.DropdownIndicator>
        );
    };

    return (
        <StyledComponent
            className={classnames(
                'layout-forms-select',
                [
                    `style-${style}`,
                    `name-${name}`,
                ],
                {
                    'error': Boolean(error),
                    'disabled': Boolean(disabled),
                    'decorator-left': Boolean(
                        error && validationAction === ValidationActions.Decorator ||
                        decoratorLeft && decoratorLeft.visible !== false
                    ),
                    'decorator-right': Boolean(decoratorRight && decoratorRight.visible !== false),
                }
            )}
            style={styles}
        >
            <InputWrapper
                name={name}
                label={label}
                helper={helper}
                error={errorMessage}
                validationAction={validationAction}
                decoratorLeft={decoratorLeft}
                decoratorRight={decoratorRight}
            >
                <Select
                    instanceId={name}
                    name={name}
                    options={options}
                    value={value}
                    placeholder={placeholder}
                    onChange={(option: Option<any>) => {
                        formik?.setFieldError(name, null);
                        onChange(option);
                    }}
                    isDisabled={disabled}
                    noOptionsMessage={() => emptyText}
                    isClearable={true}
                    {...inputProps}
                    components={{ DropdownIndicator }}
                    styles={customStyles}
                />
            </InputWrapper>
            {error && <small className="error-message">{error}</small>}
        </StyledComponent>
    );
};

export default LayoutFormsSelect;
